export default __webpack_public_path__ + "images/c42442cd899edd8d4d5e209fd5c59f4f-YGP_citybrowseheader_LA_791x488px@2x.webp";